import { getAlarmColorState } from "../../tools";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Dialog,
  DialogTitle,
  Divider,
  IconButton,
  Paper,
  Stack,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import AckAlarmComp from "../ack-alarm/ackAlarm";

const Item = styled(Paper)(({ theme, bgcolor = 'darkorange' }) => ({
  backgroundColor: bgcolor,
  color: "white",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  // color: theme.palette.text.secondary,
}));

function DriverAlarmsComp() {
  // const [bgColor, setBgColor] = useState('darkorange');
  const [driverAlarms, setDriverAlarms] = useState([]);
  const [openAlarmAckDialog, setOpenAlarmAckDialog] = useState({
    open: false,
  });

  const axiosPrivate = useAxiosPrivate();

  const getDriverAlarms = () => {
    axiosPrivate
      .get("/DriverAlarms/GetDriverAlarms")
      .then(function (response) {
        // console.log(response);
        if (typeof response.data === "object") {
          setDriverAlarms(response.data);
        }
      })
      .catch(function (error) {
        // console.log(error);
      });

    //auth.userProfile.driver_enroll === "1"
    // axiosPrivate
    //   .post(
    //     "/DriverAlarms/AddNewAlarm/1100553196/testInsert/driverUsername Test"
    //   )
    //   .then(function(response) {
    //     console.log(response);
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });
  };

  const handleDriverAlertSnoozeClick = (alarmId) => {
    // trigger_stamp to S and the ack_stamp to NOW + 30 minutes
    axiosPrivate
      .post("/DriverAlarms/EditAlarmStatus", {
        AckStatus: "S",
        AlarmID: alarmId,
      })
      .then(function (response) {
        console.log(response);
        if (response.status === 200) {
          setDriverAlarms(
            driverAlarms.filter((alarm) => alarm.AlarmID !== alarmId)
          );
        }
      });
  };

  const handleAckClose = () => {
    setOpenAlarmAckDialog({ open: false });
  }
  const handleAckTimeSelect = (timestamp, ackReason, alarmId, digitalInput) => {
    //If they press the Ack (acknowledge) button, they must be asked to specify the number of hours from a list and provide a reason which will be at least 7 characters long, it must set ack_flag, to A, ack stamp to NOW + number of hours, ack_user to the current logged in user (for now the account code), the ack_reason.    
    console.log(timestamp, ackReason, alarmId);
    axiosPrivate
      .post("/DriverAlarms/EditAlarmStatus", {
        AckStatus: "A",
        AlarmID: alarmId,
        AcknowledgeDuration: timestamp,
        AckReason: ackReason,
        digitalinputb: digitalInput
      })
      .then(function (response) {
        //console.log(response);
        if (response.status === 200) {
          setOpenAlarmAckDialog({ open: false });
          setDriverAlarms(
            driverAlarms.filter((alarm) => alarm.AlarmID !== alarmId)
          );
        }
      });
  };
  // const getColorState = (alarm) => {
  //   if (alarm) {
  //     console.log("getColorState", alarm.digitalinputb);
  //     //(alarm.digitalinputb && alarm.AlarmType.indexOf(alarm.digitalinputb.ident) == 0) ? (alarm.digitalinputb.states && alarm.digitalinputb.states.find(item => item.this.state.toString().toLowerCase() === alarm.AlarmType.replace(alarm.digitalinputb.ident,"").trim()).value==1 ? '#71816D' : '#DA667B'): 'darkorange'
  //     if (alarm.digitalinputb && alarm.AlarmType.indexOf(alarm.digitalinputb.ident) == 0) {
  //       if (alarm.digitalinputb.states) {
  //         const matchingState = alarm.digitalinputb.states.find(item => item.state.toString().toLowerCase() === alarm.AlarmType.replace(alarm.digitalinputb.ident, "").trim().toLowerCase());
  //         if (matchingState && matchingState.value == 1) {
  //           return '#71816D';
  //         } else if (matchingState && matchingState.value == 0) {
  //           return '#DA667B';
  //         } else {
  //           return '#CDD1DE';
  //         }
  //       }
  //     }
  //   }
  //   return 'darkorange';
  // }
  useEffect(() => {
    // TODO: re-enable polling when done debugging
    // getDriverAlarms();
    // let alarmInterval = setInterval(function () {
    //   getDriverAlarms();
    // }, 60000 * process.env.REACT_APP_ALARM_MINS);

    // return () => {
    //   if (alarmInterval) {
    //     clearInterval(alarmInterval);
    //   }
    // };
  }, []);
  return (
    <div>
      {driverAlarms && driverAlarms.length > 0 && (
        <div
          style={{
            zIndex: 1000, //consider 1055 to cover driver management 'add new driver' button
            position: "fixed",
            right: "20px",
            bottom: "20px",
            height: "calc(100% - 160px)",
            overflow: "hidden",
          }}
        >
          <Stack spacing={2}>
            {driverAlarms.map((alarm, index) => {
              return (
                <Item bgcolor={getAlarmColorState(alarm)} //{(alarm.digitalinputb && alarm.AlarmType.indexOf(alarm.digitalinputb.ident) == 0) ? (alarm.digitalinputb.states && alarm.digitalinputb.states.find(item => item.this.state.toString().toLowerCase() === alarm.AlarmType.replace(alarm.digitalinputb.ident,"").trim()).value==1 ? '#71816D' : '#DA667B'): 'darkorange' }
                  key={index}
                  sx={{
                    width: "250px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "12px",
                  }}
                >
                  <FontAwesomeIcon icon="bell" size="lg" />
                  <Divider
                    sx={{ margin: "0 5px", borderColor: "white" }}
                    orientation="vertical"
                    flexItem
                  />
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        display: "flex", flexDirection:"row",
                        gap: "7px",
                        alignItems: "center",
                      }}
                    >
                      <Tooltip
                        title={alarm.Display && alarm.Display != ""
                          ? alarm.Display
                          : ""}
                      >
                        <div
                          className="text-long"
                          style={{ maxWidth: "140px" }}
                        >
                          {alarm.Display && alarm.Display!=""
                            ? alarm.Display                                                          
                            : ""}
                        </div>
                      </Tooltip>
                      <Tooltip
                        title={alarm.DriverUsername && alarm.DriverUsername != "NONE"
                          ? "Driver: " + alarm.DriverUsername
                          : ""
                        }
                      >
                        <div
                          className="text-long"
                          style={{ maxWidth: "140px" }}
                        >
                          {alarm.DriverUsername && alarm.DriverUsername!="NONE"
                              ? "Driver: " + alarm.DriverUsername
                              : ""
                            }
                        </div>
                      </Tooltip>                      
                    </div>
                    <div style={{
                      display: "flex",flexDirection:"row",justifyContent:"space-between",
                      gap: "5px",
                      alignItems: "center",padding:"5px 0px 5px 0px"
                    }}>
                      <Tooltip title={alarm.AlarmType}>
                        <div
                          className="text-long"
                          style={{
                            float: "left",
                            fontSize: "18px",
                            maxWidth: "200px",
                          }}
                        >
                          {alarm.AlarmType}
                        </div>
                      </Tooltip>
                      {alarm.digitalinputb==null || (alarm.digitalinputb && alarm.AlarmType.indexOf(alarm.digitalinputb.ident) !=0) ?
                        <div style={{ marginLeft: "auto" }}>
                          <Tooltip title="Snooze">
                            <IconButton
                              color="inherit"
                              size="small"
                              onClick={() =>
                                handleDriverAlertSnoozeClick(alarm.AlarmID)
                              }
                            >
                              <FontAwesomeIcon icon="clock" size="sm" />
                            </IconButton>
                          </Tooltip>
                          {/* <span>/</span> */}
                        </div>
                        : null}
                      <Tooltip title="Acknowledge">
                        <IconButton
                          color="inherit"
                          size="small"
                          onClick={() =>
                            setOpenAlarmAckDialog({ open: true, id: alarm.AlarmID, digitalin: alarm.digitalinputb, alarmtype: alarm.AlarmType, display: alarm.Display, stamp: alarm.trigger_stampfmt })
                          }
                        >
                          <FontAwesomeIcon icon="circle-check" size="sm" />
                        </IconButton>
                      </Tooltip>
                    </div>
                    
                    <div
                      className="text-long"
                      style={{
                        float: "left",
                        fontSize: "8px",
                        maxWidth: "200px",
                      }}
                    >
                      {alarm.trigger_stampfmt}
                    </div>
                  </div>
                </Item>
              );
            })}
          </Stack>
        </div>
      )}

      <Dialog
        open={
          openAlarmAckDialog && openAlarmAckDialog.id
            ? openAlarmAckDialog.open
            : false
        }
      >
        {(openAlarmAckDialog.digitalin) ? <DialogTitle>Confirm acknowledgement</DialogTitle>
        : <DialogTitle>Select time and reason for acknowledge</DialogTitle>
        }        
        <AckAlarmComp
          Open={openAlarmAckDialog.open}
          AlarmId={openAlarmAckDialog.id}
          DigitalInput={openAlarmAckDialog.digitalin}
          AlarmType={openAlarmAckDialog.alarmtype}
          Display={openAlarmAckDialog.display}
          Stamp={ openAlarmAckDialog.stamp  }
          handleAckTimeSelect={handleAckTimeSelect}
          handleAckClose={handleAckClose}
        />
      </Dialog>
    </div>
  );
}

export default DriverAlarmsComp;
